import parametersService from '../../services/parameters/ParametersService.js'
import i18n from "../../i18n/index"

export default {
    name: "ParametersList",
    data() {
        return {
            search: "",
            pagination: {},
            parameters: [],
            headers: [{
                    text: i18n.t('headers.name'),
                    sortable: false,
                    value: "name"
                },
                {
                    text: i18n.t('headers.value'),
                    sortable: false,
                    value: "value"
                }
            ]
        };
    },
    methods: {
        update(item) {
            this.$emit('update', item)
        },
        getParameters() {
            const { page, rowsPerPage } = this.pagination;
            parametersService.getParameters(page - 1, rowsPerPage, this.search).then(response => {
                this.parameters = response.data;
            });
        },
        customFilter(items, search, filter) {
            search = search.toString().toLowerCase()
            return items.filter(row => filter(row["name"], search));
        }
    },
    mounted() {
        this.getParameters()

    },
    watch: {
        pagination: {
            handler() {
                //this.getBranches();
            },
            deep: true
        }
    },
}